import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";

// Layout Components
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

// Public Pages
import HomePage from "./pages/HomePage";
import MairiePage from "./pages/MairiePage";
import DecouvrirPage from "./pages/DecouvrirPage";
import VieQuotidiennePage from "./pages/VieQuotidiennePage";
import ProjetsPage from "./pages/ProjetsPage";
import MediasPage from "./pages/MediasPage";
import DiasporaPage from "./pages/DiasporaPage";
import ContactPage from "./pages/ContactPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import DocumentsPage from "./pages/DocumentsPage";
import SearchResultsPage from "./pages/SearchResultsPage";

// Admin Pages
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout wrapper for public pages
const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdminPage = pathname.startsWith('/admin');

  if (isAdminPage) {
    return children;
  }

  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors />
        <PublicLayout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/mairie" element={<MairiePage />} />
            <Route path="/mairie/conseil" element={<MairiePage />} />
            <Route path="/mairie/services" element={<MairiePage />} />
            <Route path="/mairie/demarches" element={<MairiePage />} />
            <Route path="/mairie/transparence" element={<MairiePage />} />
            <Route path="/decouvrir" element={<DecouvrirPage />} />
            <Route path="/vie-quotidienne" element={<VieQuotidiennePage />} />
            <Route path="/projets" element={<ProjetsPage />} />
            <Route path="/projets/:id" element={<ProjectDetailPage />} />
            <Route path="/medias" element={<MediasPage />} />
            <Route path="/actualites/:id" element={<ArticleDetailPage />} />
            <Route path="/diaspora" element={<DiasporaPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/recherche" element={<SearchResultsPage />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </PublicLayout>
      </BrowserRouter>
    </div>
  );
}

export default App;
